import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';
import configData from '../../../config.json';
import axiosConfig from '../../../utils/axiosConfig';
import { Redirect } from 'react-router-dom';
import { useParams } from 'react-router';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ResponsiveLayout from '../../Layouts/ResponsiveLayout';
import GradingItem from './GradingItem/GradingItem';
import './Grading.css';

import { Formik, Form, Field } from 'formik';

import {
    Avatar, Box, Button, FormControl, Grid, OutlinedInput, FormHelperText, InputAdornment,
    Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, Typography, Paper
} from '@material-ui/core';

import { Description as DescriptionIcon } from '@material-ui/icons';
import { StateContext, DispatchContext } from '../../../context/Provider';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(0.5),
        marginLeft: 0
    },
    textField: {
        width: '25ch',
    },
    table: {
        minWidth: 650,
    },
    input: {
        padding: "10px 14px"
    },
    helper: {
        marginLeft: 0,
        color: 'green',
        fontWeight: 'bold'
    }
}));

const TextMutedTypography = withStyles({
    root: { color: '#999999' }
})(Typography);

// function createData(name, calories, fat, carbs, protein) {
//     return { name, calories, fat, carbs, protein };
// }

// const rows = [
//     createData('Denneth Dacara', 159, 6.0, 24, 4.0),
//     createData('Juan Dela Cruz', 237, 9.0, 37, 4.3),
//     createData('John Ernest Doe', 262, 16.0, 24, 6.0),
// ];

const Grading = (props) => {

    const { classcode } = useParams();
    const classes = useStyles();

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { authState } = appState;
    const { globalDispatch } = appDispatch;

    const [sampleData, setSampleData] = useState({grade: 0});

    const [classworks, setClassworks] = useState([]);
    const [studentGrades, setStudentGrades] = useState([]);
    const [allClassworks, setAllClassworks] = useState([])

    async function fetchStudentGrades(lessons = 'all') {

        try {

            const response = await axiosConfig.get(`/grades/${classcode}?lessonFilter=${lessons}`);
            const { data } = response.data;

            console.log(data.classworks)

            setClassworks(data.classworks);
            setStudentGrades(data.students);
            setAllClassworks(data.allClassworks);
            // setClassroom(data.classroom);
            // setAnnouncements(data.announcements);

        } catch(e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    const [lesson, setLesson] = useState('all');
    const selectLesson = (event) => {
        setLesson(lesson => lesson = event.target.value)
    }

    useEffect(() => {
        globalDispatch({type: 'setIsLoading', value: true});
        fetchStudentGrades(lesson)
    }, [lesson])

    const handleExportExcel = () => {
        window.location.href = `${process.env.REACT_APP_API_URL}/exportStudentGrades?classcode=${classcode}&lessonFilter=${lesson}`;
    }

    const NoStudentsFound = () => {
        return (
            <Grid
                container
                spacing={2}
                justify="center"
            >
                <Grid item xs={12} sm={12} md={10} lg={8} xl={8}>
                    <Paper>
                        <Box px={2} py={5}>
                            <Typography variant="body2" color="textSecondary" component="p" align="center">
                                No students found.
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        );
    }

    useEffect(() => {

        if (!classcode) {
            <Redirect to="/dashboard" />;
        }

        globalDispatch({type: 'setIsLoading', value: true});
        globalDispatch({type: 'setTabValue', value: 3});
        globalDispatch({type: 'setShowTabs', value: true});

        const source = axiosConfig.CancelToken.source();
        fetchStudentGrades();
        return () => {
            source.cancel();
        }

        // setTimeout(() => globalDispatch({type: 'setIsLoading', value: false}), 500);

    }, []);

    return (
        <ResponsiveLayout classcode={classcode}>

            <Box mt={2} />

            { studentGrades.length === 0
                ? <NoStudentsFound />
                : (<>
                    { authState.user.role_id !== 5 && (
                        <Grid item xs={12} sm={12} md={10} lg={8} xl={8}>
                            <div className={classes.inlineButtons}>
                                <Button
                                    disableRipple
                                    color="primary"
                                    variant="outlined"
                                    size="medium"
                                    startIcon={<DescriptionIcon />}
                                    onClick={handleExportExcel}
                                >
                                    Export to Excel
                                </Button>
                                <FormControl className={`lesson-dropdown ${classes.formControl}`}>
                                    <Select
                                        value={lesson}
                                        onChange={selectLesson}
                                        displayEmpty
                                        className={classes.selectEmpty}
                                        inputProps={{ 'aria-label': 'Without label' }}
                                        variant="outlined"
                                        color="primary"
                                    >
                                        <MenuItem value="all">
                                            <em>-- Show All Lessons --</em>
                                        </MenuItem>
                                        { allClassworks.map((cw, index) => (
                                            <MenuItem value={cw.id} key={cw.id}>{cw.topic_name}</MenuItem>
                                        )) }
                                    </Select>
                                </FormControl>
                            </div>
                            <Box mb={2} />
                        </Grid>
                    )}

                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ width: '30%', minWidth: '300px' }}>
                                        { authState.user.role_id === 4 ? 'My Students' : 'My Grades' }
                                    </TableCell>
                                    { classworks.map((cw, index) => (
                                        <TableCell align="left" key={cw.id}>
                                            <TextMutedTypography>
                                                Due: {cw.due_date || 'N/A'}
                                            </TextMutedTypography>
                                            <Typography style={{fontWeight: '750', fontSize: '12px'}}>
                                                {cw.topic_name || ''}
                                            </Typography>

                                            <Box mt={1} />

                                            <Typography style={{fontWeight: '550'}}>
                                                {cw.title}
                                            </Typography>
                                            <TextMutedTypography>
                                                Out of {cw.total_pts || 0}
                                            </TextMutedTypography>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {studentGrades.map((student, index) => (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row">
                                            <Grid container direction="row" alignItems="center" spacing={2} style={{flexWrap: 'nowrap'}}>
                                                <Grid item>
                                                    <Avatar alt="avatar" src={student.avatar} />
                                                </Grid>
                                                <Grid item>
                                                    {student.name}
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                        {student.student_classworks.map((cw, i) => (
                                            <GradingItem
                                                key={i}
                                                cw={cw}
                                                classes={classes}
                                                fetchStudentGrades={fetchStudentGrades}
                                            />
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>)
            }
        </ResponsiveLayout>
    );
}

export default Grading;